import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const Settings = lazyWithRetry(() => import(/* webpackChunkName: "settings" */'../../component/Settings'))

const SettingsPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<Settings />
		</Suspense>
	)
})

SettingsPage.displayName = 'SettingsPage'
export default SettingsPage
